<div>
    <div></div>
    <div>
        <h6>Need help? Contact Yello Help Center</h6>
        <a href="tel:+971 54 399 5399">+971 54 399 5399</a>
        <p><span>09AM - 09PM</span><span>Mon - Thu & Sat - Sun</span></p>
    </div>
</div>